import { useState } from 'react';
import { cancelFunctions } from 'utils/cancelFunctions';
import { getDealsWithBids } from 'modules/api/deals';

type UseMetricsData = {
  numberOfLiveDeals: string | null;
  isLoadingLiveDeals: boolean;
  getNumberOfLiveDeals: () => Promise<void>;
};

export const useMetricsData = (): UseMetricsData => {
  const [numberOfLiveDeals, setNumberOfLiveDeals] = useState<string | null>(null);
  const [isLoadingLiveDeals, setIsLoadingLiveDeals] = useState(false);

  const getNumberOfLiveDeals = async (): Promise<void> => {
    try {
      setIsLoadingLiveDeals(true);
      const { totalElements } = await getDealsWithBids({
        cancelFunctions,
        filters: {
          time: 'PLAY',
          status: 'LIVE',
        },
        page: 1,
        size: 1,
        sort: {},
        cancelName: 'GET_LIVE_DEALS_COUNT',
      });

      setNumberOfLiveDeals(`${totalElements}`);
      // eslint-disable-next-line no-empty
    } catch {
    } finally {
      setIsLoadingLiveDeals(false);
    }
  };

  return {
    numberOfLiveDeals,
    isLoadingLiveDeals,
    getNumberOfLiveDeals,
  };
};
